import React from 'react';
import { X, Download, Mail, Printer, FileSpreadsheet } from 'lucide-react';
import { downloadQuotationExcel } from '../../services/excelGenerator';
import { downloadQuotationPDFExact, previewInvoiceHTML } from '../../services/pdfGenerator';

const ViewQuotationModal = ({ quotation, onClose }) => {
    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
        }).format(amount);
    };

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };

    const getStatusBadge = (status) => {
        const statusConfig = {
            pending: { bg: '#fffbeb', color: '#f59e0b', text: 'Pending' },
            approved: { bg: '#ecfdf5', color: '#059669', text: 'Approved' },
            rejected: { bg: '#fef2f2', color: '#dc2626', text: 'Rejected' },
            expired: { bg: '#f3f4f6', color: '#6b7280', text: 'Expired' }
        };

        const config = statusConfig[status] || statusConfig.pending;

        return (
            <span style={{
                padding: '6px 16px',
                borderRadius: '20px',
                fontSize: '14px',
                fontWeight: '600',
                backgroundColor: config.bg,
                color: config.color
            }}>
        {config.text}
      </span>
        );
    };

    const getExpiryDate = () => {
        const created = new Date(quotation.createdAt);
        const expiry = new Date(created.getTime() + (quotation.validityDays * 24 * 60 * 60 * 1000));
        return expiry;
    };

const handleExportToExcel = async () => {
    console.log('🚀 Exporting quotation to Excel:', quotation);
    
    // Optional: Preview the data first (for debugging)
    
    // Generate and download the Excel file
    const result = await downloadQuotationExcel(quotation);
    
    if (result.success) {
        console.log(`✅ Excel file downloaded: ${result.filename}`);
    } else {
        console.error('❌ Failed to export Excel:', result.error);
        alert('Failed to export Excel file: ' + result.error);
    }
};

const handleDownload = async () => {
    console.log('🚀 Exporting quotation to Excel:', quotation);
    
    try {
    const result = await downloadQuotationPDFExact(quotation);
        if (result.success) {
            console.log(`✅ Excel file downloaded: ${result.filename}`);
        } else {
            console.error('❌ Failed to export Excel:', result.error);
            alert('Failed to export Excel file: ' + result.error);
        }
    } catch (error) {
        console.error('❌ Excel generation error:', error);
        alert('Failed to generate Excel file: ' + error.message);
    }
};

    const handleEmailQuotation = () => {
        console.log('Emailing quotation:', quotation);
        // Implementation would go here
    };

    const handlePrint = () => {
        window.print();
    };

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
            padding: '20px'
        }}>
            <div style={{
                backgroundColor: 'white',
                borderRadius: '12px',
                width: '100%',
                maxWidth: '900px',
                maxHeight: '90vh',
                overflow: 'hidden',
                boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)'
            }}>
                {/* Header */}
                <div style={{
                    padding: '24px',
                    borderBottom: '1px solid #e5e7eb',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}>
                    <div>
                        <h2 style={{
                            fontSize: '24px',
                            fontWeight: '700',
                            color: '#1f2937',
                            margin: '0 0 4px 0'
                        }}>
                            Quotation Details
                        </h2>
                        <p style={{
                            fontSize: '14px',
                            color: '#6b7280',
                            margin: 0
                        }}>
                            {quotation.quotationNumber}
                        </p>
                    </div>

                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px'
                    }}>
                    <button
                        onClick={handleExportToExcel}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                            padding: '8px 16px',
                            backgroundColor: '#059669',
                            color: 'white',
                            border: 'none',
                            borderRadius: '6px',
                            fontSize: '14px',
                            fontWeight: '500',
                            cursor: 'pointer'
                        }}
                    >
                        <FileSpreadsheet size={16} />
                        Export Excel
                    </button>
                    <button
                        onClick={handleDownload}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                            padding: '8px 16px',
                            backgroundColor: '#059669',
                            color: 'white',
                            border: 'none',
                            borderRadius: '6px',
                            fontSize: '14px',
                            fontWeight: '500',
                            cursor: 'pointer'
                        }}
                    >
                        <Download size={16} />
                        Export
                    </button>

                        <button
                            onClick={handleEmailQuotation}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px',
                                padding: '8px 16px',
                                backgroundColor: '#1e40af',
                                color: 'white',
                                border: 'none',
                                borderRadius: '6px',
                                fontSize: '14px',
                                fontWeight: '500',
                                cursor: 'pointer'
                            }}
                        >
                            <Mail size={16} />
                            Email
                        </button>

                        <button
                            onClick={handlePrint}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px',
                                padding: '8px 16px',
                                backgroundColor: '#f59e0b',
                                color: 'white',
                                border: 'none',
                                borderRadius: '6px',
                                fontSize: '14px',
                                fontWeight: '500',
                                cursor: 'pointer'
                            }}
                        >
                            <Printer size={16} />
                            Print
                        </button>

                        <button
                            onClick={onClose}
                            style={{
                                padding: '8px',
                                backgroundColor: 'transparent',
                                border: 'none',
                                borderRadius: '6px',
                                cursor: 'pointer',
                                color: '#6b7280'
                            }}
                        >
                            <X size={24} />
                        </button>
                    </div>
                </div>

                {/* Content */}
                <div style={{
                    padding: '32px',
                    overflowY: 'auto',
                    maxHeight: 'calc(90vh - 140px)'
                }}>
                    {/* Company Header */}
                    <div style={{
                        textAlign: 'center',
                        marginBottom: '40px',
                        paddingBottom: '24px',
                        borderBottom: '2px solid #e5e7eb'
                    }}>
                        <h1 style={{
                            fontSize: '32px',
                            fontWeight: '700',
                            color: '#1e40af',
                            margin: '0 0 8px 0'
                        }}>
                            UNITECH IKK
                        </h1>
                        <p style={{
                            fontSize: '16px',
                            color: '#6b7280',
                            margin: 0
                        }}>
                            Professional Engineering Solutions
                        </p>
                    </div>

                    {/* Quotation Info */}
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr',
                        gap: '32px',
                        marginBottom: '32px'
                    }}>
                        {/* Client Information */}
                        <div>
                            <h3 style={{
                                fontSize: '18px',
                                fontWeight: '600',
                                color: '#1f2937',
                                marginBottom: '16px'
                            }}>
                                Bill To:
                            </h3>
                            <div style={{
                                backgroundColor: '#f9fafb',
                                padding: '20px',
                                borderRadius: '8px',
                                border: '1px solid #e5e7eb'
                            }}>
                                <p style={{
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    color: '#1f2937',
                                    margin: '0 0 8px 0'
                                }}>
                                    {quotation.clientName}
                                </p>
                                <p style={{
                                    fontSize: '14px',
                                    color: '#6b7280',
                                    margin: '0 0 4px 0'
                                }}>
                                    {quotation.clientEmail}
                                </p>
                                {quotation.clientPhone && (
                                    <p style={{
                                        fontSize: '14px',
                                        color: '#6b7280',
                                        margin: '0 0 4px 0'
                                    }}>
                                        {quotation.clientPhone}
                                    </p>
                                )}
                                <p style={{
                                    fontSize: '14px',
                                    color: '#6b7280',
                                    margin: 0
                                }}>
                                    Project: {quotation.projectName}
                                </p>
                            </div>
                        </div>

                        {/* Quotation Details */}
                        <div>
                            <h3 style={{
                                fontSize: '18px',
                                fontWeight: '600',
                                color: '#1f2937',
                                marginBottom: '16px'
                            }}>
                                Quotation Details:
                            </h3>
                            <div style={{
                                backgroundColor: '#f9fafb',
                                padding: '20px',
                                borderRadius: '8px',
                                border: '1px solid #e5e7eb'
                            }}>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    marginBottom: '8px'
                                }}>
                                    <span style={{ fontSize: '14px', color: '#6b7280' }}>Quotation #:</span>
                                    <span style={{ fontSize: '14px', fontWeight: '600', color: '#1f2937' }}>
                    {quotation.quotationNumber}
                  </span>
                                </div>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    marginBottom: '8px'
                                }}>
                                    <span style={{ fontSize: '14px', color: '#6b7280' }}>Date:</span>
                                    <span style={{ fontSize: '14px', fontWeight: '500', color: '#1f2937' }}>
                    {formatDate(quotation.createdAt)}
                  </span>
                                </div>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    marginBottom: '8px'
                                }}>
                                    <span style={{ fontSize: '14px', color: '#6b7280' }}>Valid Until:</span>
                                    <span style={{ fontSize: '14px', fontWeight: '500', color: '#1f2937' }}>
                    {formatDate(getExpiryDate())}
                  </span>
                                </div>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center'
                                }}>
                                    <span style={{ fontSize: '14px', color: '#6b7280' }}>Status:</span>
                                    {getStatusBadge(quotation.status)}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Items Table */}
                    <div style={{ marginBottom: '32px' }}>
                        <h3 style={{
                            fontSize: '18px',
                            fontWeight: '600',
                            color: '#1f2937',
                            marginBottom: '16px'
                        }}>
                            Items:
                        </h3>

                        <div style={{
                            border: '1px solid #e5e7eb',
                            borderRadius: '8px',
                            overflow: 'hidden'
                        }}>
                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <thead>
                                <tr style={{ backgroundColor: '#f9fafb' }}>
                                    <th style={{
                                        padding: '16px',
                                        textAlign: 'left',
                                        fontSize: '12px',
                                        fontWeight: '600',
                                        color: '#374151',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.05em'
                                    }}>
                                        Item Description
                                    </th>
                                    <th style={{
                                        padding: '16px',
                                        textAlign: 'center',
                                        fontSize: '12px',
                                        fontWeight: '600',
                                        color: '#374151',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.05em',
                                        width: '100px'
                                    }}>
                                        Qty
                                    </th>
                                    <th style={{
                                        padding: '16px',
                                        textAlign: 'right',
                                        fontSize: '12px',
                                        fontWeight: '600',
                                        color: '#374151',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.05em',
                                        width: '120px'
                                    }}>
                                        Unit Price
                                    </th>
                                    <th style={{
                                        padding: '16px',
                                        textAlign: 'right',
                                        fontSize: '12px',
                                        fontWeight: '600',
                                        color: '#374151',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.05em',
                                        width: '120px'
                                    }}>
                                        Total
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                {quotation.items.map((item, index) => (
                                    <tr
                                        key={index}
                                        style={{
                                            borderBottom: index < quotation.items.length - 1 ? '1px solid #f3f4f6' : 'none'
                                        }}
                                    >
                                        <td style={{ padding: '16px' }}>
                                            <div>
                                                <div style={{
                                                    fontSize: '14px',
                                                    fontWeight: '500',
                                                    color: '#1f2937',
                                                    marginBottom: '4px'
                                                }}>
                                                    {item.description}
                                                </div>
                                                <div style={{
                                                    fontSize: '12px',
                                                    color: '#6b7280'
                                                }}>
                                                    Item #: {item.itemNo}
                                                </div>
                                            </div>
                                        </td>
                                        <td style={{
                                            padding: '16px',
                                            textAlign: 'center',
                                            fontSize: '14px',
                                            color: '#1f2937'
                                        }}>
                                            {item.quantity}
                                        </td>
                                        <td style={{
                                            padding: '16px',
                                            textAlign: 'right',
                                            fontSize: '14px',
                                            color: '#1f2937'
                                        }}>
                                            {formatCurrency(item.unitPrice)}
                                        </td>
                                        <td style={{
                                            padding: '16px',
                                            textAlign: 'right',
                                            fontSize: '14px',
                                            fontWeight: '600',
                                            color: '#1f2937'
                                        }}>
                                            {formatCurrency(item.totalPrice)}
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* Totals */}
                    <div style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        marginBottom: '32px'
                    }}>
                        <div style={{
                            backgroundColor: '#f9fafb',
                            padding: '24px',
                            borderRadius: '8px',
                            border: '1px solid #e5e7eb',
                            minWidth: '300px'
                        }}>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '12px'
                            }}>
                                <span style={{ fontSize: '14px', color: '#6b7280' }}>Subtotal:</span>
                                <span style={{ fontSize: '14px', fontWeight: '500', color: '#1f2937' }}>
                  {formatCurrency(quotation.totalAmount)}
                </span>
                            </div>

                            <div style={{
                                borderTop: '1px solid #e5e7eb',
                                paddingTop: '12px',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                            }}>
                <span style={{ fontSize: '18px', fontWeight: '600', color: '#1f2937' }}>
                  Total Amount:
                </span>
                                <span style={{ fontSize: '24px', fontWeight: '700', color: '#1e40af' }}>
                  {formatCurrency(quotation.totalAmount)}
                </span>
                            </div>
                        </div>
                    </div>

                    {/* Terms and Conditions */}
                    <div style={{
                        backgroundColor: '#f9fafb',
                        padding: '24px',
                        borderRadius: '8px',
                        border: '1px solid #e5e7eb'
                    }}>
                        <h4 style={{
                            fontSize: '16px',
                            fontWeight: '600',
                            color: '#1f2937',
                            marginBottom: '12px'
                        }}>
                            Terms & Conditions:
                        </h4>
                        <ul style={{
                            fontSize: '14px',
                            color: '#6b7280',
                            lineHeight: '1.6',
                            paddingLeft: '20px',
                            margin: 0
                        }}>
                            <li>This quotation is valid for {quotation.validityDays} days from the date of issue.</li>
                            <li>Prices are subject to change without prior notice after the validity period.</li>
                            <li>Payment terms: 50% advance, 50% on delivery.</li>
                            <li>Delivery time: 2-4 weeks from order confirmation.</li>
                            <li>All prices are exclusive of VAT and delivery charges.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ViewQuotationModal;